module.exports = __webpack_public_path__ + "static/media/undo.3b9ea364.svg";